var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0728 1.94062C17.9496 1.81637 17.7938 1.72957 17.6233 1.69023C17.4528 1.65089 17.2747 1.66063 17.1095 1.71833L16.8576 1.80725L2.28983 6.90522C2.11559 6.96867 1.96378 7.08179 1.85315 7.2306C1.74253 7.37942 1.67795 7.55741 1.66741 7.74254C1.66187 7.92811 1.71178 8.11111 1.81077 8.26818C1.90977 8.42525 2.05334 8.54925 2.22315 8.62431L7.66938 11.0473L8.56597 11.4475L8.98834 12.3959L11.3817 17.7903C11.4577 17.9593 11.5826 18.1016 11.7403 18.1988C11.898 18.2961 12.0813 18.3438 12.2664 18.3358C12.4515 18.3278 12.6299 18.2645 12.7787 18.1541C12.9274 18.0436 13.0396 17.8911 13.1008 17.7162L18.2877 2.8965C18.2911 2.88188 18.2911 2.86666 18.2877 2.85204C18.3402 2.69517 18.3479 2.52675 18.3099 2.36575C18.272 2.20474 18.1898 2.05751 18.0728 1.94062V1.94062Z",
    fill: "#70758F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendGrey);
export default __webpack_public_path__ + "static/media/send-grey.aadd8d7279df3fe4183d3953b642a342.svg";
export { ForwardRef as ReactComponent };